import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

interface YouTubeFormProps {
    onFieldChange: (field: string, value: string | boolean) => void;
    onFieldBlur?: (field: string, value: string | boolean) => void;
    youTubeFormState: YouTubeFormState
    disableCompilationFields?: boolean
}

export interface YouTubeFormState {
    title: string;
    description: string;
    private: boolean;
}

const YouTubeForm: React.FC<YouTubeFormProps> = ({
                                                     onFieldChange,
                                                     onFieldBlur, // Destrutturiamo la nuova prop
                                                     youTubeFormState,
                                                     disableCompilationFields = false
                                                 }) => {

    const handleBlur = (field: string, value: string | boolean) => {
        if (onFieldBlur) {
            onFieldBlur(field, value);
        }
    };

    return (
        <Grid container spacing={2}>
            <Grid size={{ md: 12, lg: 12 }}>
                <Box display="flex" flexDirection={'column'}>
                    <TextField
                        value={youTubeFormState.title}
                        name={"youtubeTitle"}
                        placeholder={"Insert title"}
                        type={'text'}
                        variant={'outlined'}
                        onChange={(e) => onFieldChange('title', e.target.value)}
                        onBlur={(e) => handleBlur('title', e.target.value)}
                        fullWidth
                        sx={{ mb: 2 }}
                        disabled={disableCompilationFields}
                    />
                    <TextField
                        multiline
                        minRows={6}
                        placeholder={'Type post description'}
                        label={'Description'}
                        value={youTubeFormState.description}
                        onChange={(e) => onFieldChange('description', e.target.value)}
                        onBlur={(e) => handleBlur('description', e.target.value)}
                        fullWidth
                        sx={{ height: '100%', display: 'flex' }}
                        disabled={disableCompilationFields}
                    />
                    <Box display={'flex'} justifyContent={'space-between'}>
                        <FormControlLabel
                            label={"Private"}
                            control={
                                <Checkbox
                                    checked={youTubeFormState.private || false}
                                    onChange={(e) => onFieldChange('private', e.target.checked)}
                                    onBlur={() => handleBlur('private', youTubeFormState.private)}
                                />
                            }
                        />
                    </Box>
                </Box>
            </Grid>
        </Grid>
    )
}

export default YouTubeForm;